import { collection, doc, onSnapshot } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { About_Type } from "../model";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const [about, setAbout] = useState<About_Type>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    onSnapshot(
      doc(collection(db, "about"), "about"),
      (snapshot) => {
        setAbout(snapshot.data() as About_Type);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  }, []);
  return (
    <section
      style={{
        backgroundImage: `url(${"https://images.unsplash.com/photo-1461749280684-dccba630e2f6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y29kaW5nfGVufDB8fDB8fHww&auto=format&fit=crop&w=800&q=60"})`,
      }}
      className="text-gray-900 bg-white py-20 p-5 h-full flex-1 relative bg-cover bg-no-repeat"
    >
      <div className="container relative mx-auto flex flex-col items-center bg-slate-950 py-5 drop-shadow">
        <div
          style={{
            backgroundImage: `url(${"https://images.unsplash.com/photo-1461749280684-dccba630e2f6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y29kaW5nfGVufDB8fDB8fHww&auto=format&fit=crop&w=800&q=60"})`,
          }}
          className="absolute top-0 right-0 bottom-0 left-0 bg-cover bg-no-repeat blur-sm"
        />
        <div className="max-w-lg text-white text-center z-10 ">
          <h1 className="text-4xl md:text-6xl font-bold mb-8">
            Welcome to My Portfolio
          </h1>
          <p className="text-lg md:text-xl mb-12">
            I am a Developer with expertise in a various programming languages
            and technologies.
          </p>
          <Link
            to={"/portfolio"}
            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-full transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110"
          >
            Explore My Work
          </Link>
        </div>
        <div className="max-w-lg mt-12 z-10">
          {loading || !about ? (
            <div className="w-40 h-40 rounded-full border-t-2 animate-spin border-white" />
          ) : (
            <img
              src={about?.image}
              alt="Profile"
              className="rounded-full mx-auto h-40 w-40 object-cover"
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
